import vuetify from '@/plugins/vuetify';
import labels from "@/constants/labels.js";
import messages from "@/constants/messages.js";
import parameters from "@/constants/parameters.js";
import calculatorsLabels from "@/constants/labels/calculators.labels.js";
const crypto = require("crypto-js");

const _getWindowHeight = (diff) => {
  return (window.innerHeight || window.screen.height) - (diff || 0);
}

const _removeAccents = function (str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
const _isValidCnpj = (cnpj) => {
  if (!cnpj || cnpj.length != 14) {
    throw new Error();
  }
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (["00000000000000",
    "11111111111111",
    "22222222222222",
    "33333333333333",
    "44444444444444",
    "55555555555555",
    "66666666666666",
    "77777777777777",
    "88888888888888",
    "99999999999999"].includes(cnpj)) {
    throw new Error();
  }

  let length = cnpj.length - 2
  let numbers = cnpj.substring(0, length);
  let digits = cnpj.substring(length);
  let sum = 0;
  let pos = length - 7;
  for (let i = length; i >= 1; i--) {
    sum += numbers.charAt(length - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let results = sum % 11 < 2 ? 0 : 11 - sum % 11;
  if (results != digits.charAt(0)) {
    throw new Error();
  }

  length = length + 1;
  numbers = cnpj.substring(0, length);
  sum = 0;
  pos = length - 7;
  for (let i = length; i >= 1; i--) {
    sum += numbers.charAt(length - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  results = sum % 11 < 2 ? 0 : 11 - sum % 11;
  if (results != digits.charAt(1)) {
    throw new Error();
  }
}

const _isValidCpf = (cpf) => {
  if (!cpf || cpf.replace(/[.-]/g, '').length != 11) {
    throw new Error();
  }
  cpf = cpf.replace(/[.-]/g, '');
  let divider;
  let sum = 0;
  if (cpf == "00000000000") throw new Error();

  for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  divider = (sum * 10) % 11;

  if ((divider == 10) || (divider == 11)) divider = 0;
  if (divider != parseInt(cpf.substring(9, 10))) throw new Error();

  sum = 0;
  for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  divider = (sum * 10) % 11;

  if ((divider == 10) || (divider == 11)) divider = 0;
  if (divider != parseInt(cpf.substring(10, 11))) throw new Error();
  return;
}

const _getTimestamp = function () {
  let date = new Date();
  return date.getTime();
}
const _isMobile = function () {
  return vuetify.framework.breakpoint.sm || vuetify.framework.breakpoint.xs;
}
const _xsOnly = function () {
  return vuetify.framework.breakpoint.xsOnly;
}

const _smoothScrollBy = function (x, y) {
  let startY = window.scrollY;
  let startX = window.scrollX;
  let endY = startY + y;
  let endX = startX + x;
  let duration = 100; // Duration in ms
  let startTime = null;

  function step(timestamp) {
    if (!startTime) {
      startTime = timestamp;
    }
    let progress = timestamp - startTime;
    let pct = Math.min(progress / duration, 1);  // Ensure the percentage does not exceed 1
    window.scrollTo(endX * pct, endY * pct);
    if (pct < 1) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

const _setupScreenContent = function (context, paddingDiff = 0) {
  setTimeout(
    function () {
      if (context.$refs.screenHeader && context.$refs.screenContent) {
        const headerHeight = context.$refs.screenHeader.offsetHeight + (context.$vuetify.breakpoint.xsOnly ? 0 : 16) - (paddingDiff || 0);
        context.$refs.screenContent.style.paddingTop = (headerHeight + 12) + "px";
        this.$refs.screenContent.classList.add('vetalfa-max-width');
        context.$vuetify.goTo(0, {
          duration: 0,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return;
      }
      _setupScreenContent(context, paddingDiff);
    }.bind(context),
    100
  );
}
const _setupScreenSizesSynchronous = function (context, paddingDiff = 0) {
  if (context._isDestroyed || context._isBeingDestroyed) return;
  if (context.$refs.screenHeader && context.$refs.screenContent) {
    const headerHeight = context.$refs.screenHeader.offsetHeight + 8 - (paddingDiff || 0);
    context.$refs.screenContent.style.paddingTop = headerHeight + "px";

    const root = document.querySelector(":root");
    root.style.setProperty("--pseudo-padding-top-global", headerHeight + "px");

    context.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
      easing: "easeInOutCubic",
    });
    if (context.scrollHeight == 0) {
      context.scrollHeight = document.body.offsetHeight - headerHeight;
    }
  }
}
const _setupScreenSizes = function (context, paddingDiff = 0) {
  setTimeout(
    function () {
      if (context._isDestroyed || context._isBeingDestroyed) return;
      if (context.$refs.screenHeader && context.$refs.screenContent) {
        const headerHeight = context.$refs.screenHeader.offsetHeight + 8 - (paddingDiff || 0);
        context.$refs.screenContent.style.paddingTop = headerHeight + "px";
        context.$vuetify.goTo(0, {
          duration: 0,
          offset: 0,
          easing: "easeInOutCubic",
        });
        if (context.scrollHeight == 0) {
          context.scrollHeight = _getWindowHeight() - headerHeight;
        }
        return;
      }
      _setupScreenSizes(context, paddingDiff);
    }.bind(context),
    100
  );
}

const _isCordovaApp = function () {
  return typeof cordova !== 'undefined' && !!cordova;
}
const _capitalize = function (s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
const _getLabel = function (propName, propOrigin = 'labels') {
  const originLabel = {
    'calculators': function () {
      return calculatorsLabels[propName];
    },
    'labels': function () {
      return labels[propName];
    }
  }
  if (originLabel[propOrigin]) {
    return originLabel[propOrigin]();
  }
  throw new Error('Invalid property.');
}
const _getParameter = function (prop) {
  return parameters[prop];
}
const _roundNumber = function (value, decimals) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}
const _formatNumber = function (x, unity = null) {
  x = x.toString().replace('.', ',');
  x = x.split(',');
  x[0] = x[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  return `${x.join(',')} ${unity || ''}`;
}
export default {
  methods: {
    _scrollToZero(ctx) {
      ctx.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
        easing: 'easeInOutCubic',
      })
    },
    _getDocumentById(id) {
      return document.getElementById(id);
    },
    _getUpperCaseFirstLetter(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase();
    },
    _getHourMinutesSeconds(d) {
      let h = Math.floor(d / 3600);
      let m = Math.floor((d % 3600) / 60);
      let s = Math.floor((d % 3600) % 60);

      let hDisplay = h > 0 ? h + (h == 1 ? " hora, " : " horas, ") : "";
      let mDisplay = m > 0 ? m + (m == 1 ? " minuto, " : " minutos, ") : "";
      let sDisplay = s > 0 ? s + (s == 1 ? " segundo, " : " segundos, ") : "";
      return (hDisplay + mDisplay + sDisplay).slice(0, -2);
    },
    _getNumber(num) {
      return new Number((num || '0').replace(',', '.'));
    },
    _strToNumber(str) {
      if (str.length && ['.', ','].includes(str[str.length - 1])) {
        str = str.slice(0, -1);
      }
      return new Number(str.replace(/\./g, '').replace(',', '.'))
    },
    _roundNumber,
    _formatNumber,
    _formatAndRoundNumber(value, decimals = 2) {
      return _formatNumber(_roundNumber(value, decimals));
    },
    _isPopulatedArray(arr) {
      return !!arr && arr.length > 0;
    },
    _getComputedStyleFromElement(el, prop) {
      return window
        .getComputedStyle(el)
        .getPropertyValue(prop);
    },
    _pixelsToNumber(pixels) {
      return Number(pixels.replace("px", "").trim());
    },
    _isValidNumber(num) {
      if (num && typeof num === 'string') {
        num = num.replace(',', '.');
      }
      return !isNaN(num) && num !== null && num !== undefined;
    },
    _isValidName(name) {
      if (!name || name.length < 2 || name.length > 50) {
        return false;
      }
      const regex = /^[a-zA-Z][a-zA-Z]*(?:-[a-zA-Z][a-zA-Z]*)?(?: [a-zA-Z][a-zA-Z]*(?:-[a-zA-Z][a-zA-Z]*)?)*$/;
      return regex.test(_removeAccents(name.trim())) && name.trim().split(' ').length > 1;
    },
    _hash(str) {
      return crypto.SHA256(str).toString();
    },
    _encrypt(obj, supressSpecialChars = false) {
      let encrypted = crypto.AES.encrypt(JSON.stringify(obj), process.env.VUE_APP_SECRET).toString();
      if (supressSpecialChars) {
        encrypted = encrypted.replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l');
      }
      return encrypted;
    },
    _decrypt(str, supressSpecialChars = false) {
      if (!str) return str;
      if (supressSpecialChars) {
        str = str.replace(/p1L2u3S/g, '+').replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=');
      }
      str = crypto.AES.decrypt(str, process.env.VUE_APP_SECRET);
      return JSON.parse(str.toString(crypto.enc.Utf8));
    },
    _getMaxWidth() {
      return 1200;
    },
    _filterArrayFromString(array, string) {
      return array.filter(o =>
        Object.keys(o).some(k =>
          o[k].toLowerCase().includes(string.toLowerCase())
        )
      );
    },
    _filterArrayFromId(array, id) {
      return array.filter(o => {
        return o.id == id;
      });
    },
    _getPlatform: function () {
      return !_isCordovaApp() ? 'website' : cordova.platformId;
    },
    _getDialogHeight(fraction = 0.8) {
      const height = _getWindowHeight();
      fraction = _isMobile() ? fraction : 0.8;
      return height * fraction;
    },
    _isAndroidWeb: function () {
      return !_isCordovaApp() && /android/i.test(navigator.userAgent);
    },
    _isIosWeb: function () {
      return !_isCordovaApp() && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    _isDesktop: function () {
      const userAgent = navigator.userAgent.toLowerCase();

      const isWindows = userAgent.indexOf('windows') !== -1;
      const isMac = userAgent.indexOf('macintosh') !== -1 || userAgent.indexOf('mac os x') !== -1;
      const isLinux = userAgent.indexOf('linux') !== -1 && userAgent.indexOf('android') === -1;
      const isDesktop = isWindows || isMac || isLinux;

      return isDesktop;
    },
    _isIos: function () {
      return _isCordovaApp() && cordova.platformId !== 'android';
    },
    _isAndroid: function () {
      return _isCordovaApp() && cordova.platformId === 'android';
    },
    _isCordovaApp,
    _getUserAgent() {
      return navigator.userAgent || navigator.vendor || window.opera;
    },
    _isMobile,
    _isNotEmpty(arr) {
      return arr && arr.length;
    },
    _removeFromArray(arr, item) {
      let temp = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] != item) {
          temp.push(arr[i]);
        }
      }
      return temp;
    },
    _removeFromArrayWithId(arr, id) {
      let temp = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id != id) {
          temp.push(arr[i]);
        }
      }
      return temp;
    },
    _doesArrayContainAllElementsOfAnother(parent, child) {
      let matchesCount = 0;
      child.forEach(c => {
        if (parent.includes(c)) {
          matchesCount += 1;
        }
      });
      return matchesCount == child.length;
    },
    _removeFromArrayWithName(arr, name) {
      let temp = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].name != name) {
          temp.push(arr[i]);
        }
      }
      return temp;
    },
    _orderById(arr) {
      arr.sort(function (a, b) {
        return a.id - b.id;
      });
      return arr;
    },
    _lang() {
      return "pt_BR"
    },
    _sortByProp(arr, prop, asc = true) {
      if (!arr) return [];
      if (asc) {
        arr = arr.sort(function (a, b) {
          return a[prop] > b[prop] ? 1 : -1;
        });
      } else {
        arr = arr.sort(function (a, b) {
          return a[prop] < b[prop] ? 1 : -1;
        });
      }
      return arr;
    },
    _setupScreenSizesSynchronous,
    _setupScreenSizes,
    _setupScreenContent,
    _getTimestamp,
    _removeAccents,
    _searchMatchTerms(item, searchTerm) {
      item = item || '';
      searchTerm = searchTerm || '';
      return _removeAccents(item.toLowerCase()).includes(_removeAccents(searchTerm.toLowerCase()));
    },
    _createIdentifier(str) {
      return str.replace(/ /g, "").split("?").join("").toLowerCase().split(".").join("").split(",").join("").split("/").join("").split("-").join("").split(":").join("").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    _capitalizeAllFirstLetters(str) {
      if (typeof str !== 'string') { throw new Error('Invalid Argument') }
      str = str.split(' ');
      for (let i = 0; i < str.length; i++) {
        str[i] = _capitalize(str[i].trim().toLowerCase());
      }
      return str.join(' ');
    },
    _capitalize,
    _validURL(str) {
      const pattern = new RegExp('^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$', 'i');
      return !!pattern.test(str);
    },
    _getWindowHeight,
    _getWindowWidth(diff) {
      return (window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth) - (diff || 0);
    },
    _shallowEqual(object1, object2) {
      if (!object1 || !object2) {
        return false;
      }

      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }

      return true;
    },
    _convertFileToDataUrl: async function (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onloadend = function () {
          resolve(reader.result);
        }

        if (file) {
          reader.readAsDataURL(file);
        } else {
          reject();
        }
      });
    },
    _getCalculatorsLabel(propName) {
      return _getLabel(propName, 'calculators');
    },
    _xsOnly,
    _getLabel,
    _getMessage(prop) {
      return messages[prop] || '';
    },
    _getParameter,
    _formatHeaderContent(context, headerRef, contentRef) {
      setTimeout(
        function () {
          if (context.$refs[headerRef] && context.$refs[contentRef]) {
            let headerHeight = context.$refs[headerRef].offsetHeight + 1;
            context.$refs[contentRef].style.paddingTop =
              headerHeight + "px";
            context.$vuetify.goTo(0, {
              duration: 0,
              offset: 0,
              easing: "easeInOutCubic",
            });
          }
        },
        100
      );
    },
    _formatNumberField(element, value = "", inputLength = 9) {
      if (element.srcElement.value.length <= inputLength) {
        element.srcElement.value = element.srcElement.value.replace(".", ",");
        let arr = element.srcElement.value.split(",");
        value = "";
        arr.forEach((item, index) => {
          if (index == 0) {
            item = parseInt(item).toString() || "";
          } else if (index == 1) {
            value += ",";
          }
          value += item.replace(/\D+/g, "");
        });
        if (value.charAt(0) == ",") {
          value = "0" + value;
        }
      }
      element.srcElement.value = value;
      return { value };
    },
    _getElapsedSeconds(startTime, endTime = null) {
      if (typeof startTime !== 'number' || (!!endTime && typeof endTime !== 'number')) {
        throw new Error();
      }
      let elapsed = endTime || _getTimestamp();
      elapsed = elapsed - startTime;
      elapsed = elapsed / 1000;
      return parseInt(elapsed);
    },
    _getLocaleDate(time) {
      if (!time) return "";
      return new Date(typeof time === 'string' ? parseInt(time) : time).toLocaleDateString(_getParameter('LOCALE'), {
        day: 'numeric', month: 'short', year: 'numeric'
      }).replace(/ /g, ' ').replace('.', '');
    },
    _isDateValidAndOverEighteen(birthday) {
      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
      if (!regex.test(birthday)) {
        return false;
      }

      const parts = birthday.split("/");
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      const date = new Date(year, month, day);
      if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
        return false;
      }
      const today = new Date();
      const eighteenthBirthday = new Date(year + 18, month, day);

      return today >= eighteenthBirthday;
    },
    _isValidBirthday(testDate) {
      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
      if (!regex.test(testDate)) {
        return false;
      }

      const parts = testDate.split("/");
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      const date = new Date(year, month, day);
      if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
        return false;
      }
      const today = new Date();
      return today >= date;
    },
    _calculateAgeFromStringBirthday(birthdayStr) {
      // Converter a string de data no formato dd/mm/yyyy para um objeto Date
      const [day, month, year] = birthdayStr.split('/').map(Number);
      const birthday = new Date(year, month - 1, day);

      // Obter a data atual
      const today = new Date();

      // Calcular a diferença em milissegundos
      const diff = today - birthday;

      // Calcular a diferença em anos
      const age = diff / (1000 * 60 * 60 * 24 * 365.25);

      // Arredondar a idade para uma casa decimal
      return _formatNumber(age.toFixed(1), labels.YEARS);
    },

    _isValidEmail: (email) => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return (
        email &&
        !!email.trim() &&
        re.test(String(email.trim()).toLowerCase())
      );
    },

    _shuffle: function (array) {
      let currentIndex = array.length, randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },

    _shuffleDateBased: (myArray) => {
      const fixedDate = new Date();
      const seed = parseInt(`${fixedDate.getDate()}${fixedDate.getMonth() + 1}${fixedDate.getFullYear()}`);

      function seededRandom(seed) {
        const x = Math.sin(seed++) * 10000;
        return x - Math.floor(x);
      }

      function fisherYatesShuffle(array, seed) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(seededRandom(seed) * (i + 1));
          seed++;
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

      return fisherYatesShuffle([...myArray], seed);
    },
    _smoothScrollBy,
    _icon(iconName) {
      return `$vuetify.icons.${iconName}`;
    },
    _testCpf(v) {
      try {
        _isValidCpf(v);
      } catch (e) {
        return false;
      }
      return true;
    },
    _formatCpf(cpf) {
      if (!cpf) return '';
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    _formatBrazilianAddress(address) {
      const {
        zipCode,
        street,
        number,
        complement,
        neighborhood,
        city,
        state
      } = address;

      // Cria um array para facilitar a montagem da string do endereço
      const addressParts = [];

      if (street) addressParts.push(street);
      if (number) addressParts.push(`nº ${number}`);
      if (complement) addressParts.push(`complemento: ${complement}`);
      if (neighborhood) addressParts.push(neighborhood);
      if (city) addressParts.push(city);
      if (state) addressParts.push(state);
      if (zipCode) addressParts.push(`CEP: ${zipCode}`);

      // Junta todas as partes com uma vírgula e um espaço
      return addressParts.join(', ');
    },
    _testBrazilianZipCode(v) {
      return /^\d{5}-\d{3}$/.test(v);
    },
    _getDateFromTimestamp(timestamp) {
      return new Date(timestamp).toLocaleDateString(_getParameter('LOCALE'));
    }
  },
};
